import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/approval-center',
  component: layout,
  meta: { funcID: 'E0014', PID: 'E00' },
  children: ((pre) => [
    {
      path: 'todo',
      name: `${pre}todo`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E001401',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/approval-center/todo'),
    },
  ])('ecom-approval-center-'),
}
